import type { FC } from 'react';
import React, { useEffect, useState, cloneElement } from 'react';
import { useCookies } from 'react-cookie';

import { draftCookieHandler } from './helpers';
import type { IState, TDcDraft } from './models';

export const DcDraft: FC<React.PropsWithChildren<TDcDraft>> = ({
    DraftOffer,
    alt,
    cards,
    children,
    cookieName = 'dc-draft',
    imgHeight,
    imgWidth,
    pictureSrc,
    progressBar,
    showDraftAnalytics,
    timetText,
    ...otherProps
}) => {
    const [cookies] = useCookies([cookieName]);
    const [draft, setDraft] = useState<IState>({
        showDraft: false,
        agreeHref: '',
        userName: '',
        cardLabel: '',
        draftWasShown: false,
    });
    const { agreeHref, cardLabel, draftWasShown, showDraft, userName } = draft;

    const onClickDisagree = () => {
        setDraft({
            ...draft,
            showDraft: false,
        });
    };

    useEffect(() => {
        const draftCookie = cookies ? cookies[cookieName] : {};
        const draftCookieState = draftCookieHandler({
            cookie: draftCookie,
            cards,
            showDraftAnalytics,
        });

        if (draftCookieState) {
            setDraft({
                ...draftCookieState,
                draftWasShown: true,
            });
        }
    }, [cards, cookieName, cookies, showDraftAnalytics]);

    const childrenWithNewProps = cloneElement(children, {
        draftShown: draftWasShown,
        formAction: {
            ...children.props.formAction,
            popupShown: draftWasShown,
        },
    });

    if (!showDraft) {
        return childrenWithNewProps;
    }

    return (
        <DraftOffer
            {...otherProps}
            agreeHref={agreeHref}
            cardLabel={cardLabel}
            onClickDisagree={onClickDisagree}
            progressBar={progressBar}
            timetText={timetText}
            userName={userName}
        />
    );
};
